module.exports = __webpack_public_path__ + "static/media/025.32a548ab.png";